module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ../node_modules/lodash/extend.js
// module id = 1807
// module chunks = 92